// extracted by mini-css-extract-plugin
export default {"container":"Price_container__6CjnD","button":"Price_button__qXekW","contacts":"Price_contacts__-x91t","address":"Price_address__ptaWL"};